<template>
  <div class="main">
    <transition appear name="fade-in">
      <background :game="game" />
    </transition>
    <!-- <Friends v-if="friendsOpened" /> -->
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Friends from "@/components/ui/Friends.vue";

export default {
  components: {
    // Friends
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({
      game: state => state.game,
      friendsOpened: state => state.friendsOpened
    })
  },

  mounted() {
    const link = document.querySelector(".notice a");
    if (link) {
      link.id = "pad-notice";
      link.setAttribute("pad-up", "go:#pad-home");
      link.setAttribute("pad-right", "go:#pad-news-1");
      link.setAttribute("pad-down", "go:#pad-play,#pad-get-game");
      link.setAttribute("pad-a", "click");
    }
  }
};
</script>

<style lang="scss" scoped>
// ===================
//    animation
// ===================
.fade-in-enter {
  opacity: 0;
  filter: grayscale(1);
}

.fade-in-enter-to {
  opacity: 1;
  transition: opacity 1500ms ease-in, filter 1000ms ease-in 1000ms;
  filter: grayscale(0);
}
</style>
